import AcDashboardOverviewTab from './overview/overview';
import AcDashboardStatsTab from './stats/stats';

export default {
  Overview: AcDashboardOverviewTab,
  Stats: AcDashboardStatsTab,
};
